import { CheckCircle, ArrowRight } from "lucide-react";

export const ItStakeholderTakeaway = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-primary/5 via-indigo-500/5 to-primary/5 border border-primary/20 rounded-2xl p-5 sm:p-6">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-24 bg-primary/10 blur-3xl" />
      
      <div className="relative flex items-start gap-4">
        <div className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-primary/15 flex items-center justify-center">
          <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
        </div>
        <div className="flex-1">
          <h2 className="font-display text-lg sm:text-xl font-semibold text-foreground mb-2">
            Know Who Owns What Before You Start
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
            <span className="font-semibold text-foreground">80% of IT project failures trace back to unclear stakeholder responsibilities.</span>{" "}
            Understanding the difference between a CTO (strategy and innovation), CIO (operations and governance), 
            IT Director (execution), and DevOps Engineer (delivery) prevents bottlenecks, miscommunication, and scope creep.
          </p>
          <div className="flex items-center gap-2 mt-3 text-sm text-primary font-medium">
            <ArrowRight className="w-4 h-4" />
            <span>Learn each role's responsibilities below</span>
          </div>
        </div>
      </div>
    </div>
  );
};
